export const redirectOnUnauthenticated = () => {
	const _return = encodeURIComponent(window.location.href);
	return (window.location.href = `/accounts/Authentication/Signin?ReturnUrl=${_return}`);
};

export const redirectToLogout = () => {
	return (window.location.href = `accounts/Authentication/Logout`);
};
